import React, { useEffect, useRef, useCallback } from 'react'
import Player from '@vimeo/player'

import styles from './modal.module.css'

function VideoModal({
  videoId,
  closeModal,
  artist,
  track,
  campaign,
  onClickTrack,
  onClickArtist,
  hasTrack,
}) {
  const playerRef = useRef(null)
  const closeThatModal = useCallback(closeModal, [closeModal])
  useEffect(() => {
    let player = new Player(playerRef.current, {
      id: videoId,
      width: 1600,
    })
    player.play()
    player.on('ended', () => setTimeout(closeThatModal, 250))
    return () => {
      player.destroy()
      // player.unload()
    }
  }, [videoId, closeThatModal])

  function trackClickHandler() {
    closeModal()
    onClickTrack()
  }
  function artistClickHandler() {
    closeModal()
    onClickArtist()
  }

  return (
    <>
      <div className={styles.videoWrapper} ref={playerRef}></div>
      <p className={styles.videoDesc}>
        <button className={styles.link} onClick={artistClickHandler}>
          <strong>{artist}</strong>
        </button>
        ,{' '}
        {hasTrack ? (
          <button className={styles.link} onClick={trackClickHandler}>
            {track}
          </button>
        ) : (
          track
        )}{' '}
        <span style={{ color: 'var(--c-red)', marginLeft: '1em' }}>
          {campaign}
        </span>
      </p>
    </>
  )
}

export default VideoModal
